import React, { PureComponent } from 'react';

export default class Footer extends PureComponent {
  render() {
    return (
      <footer className="d-print-none main-footer text-right">
        <strong>
          Copyright &copy; 2021{' '}
          <a href="https://itlogiko.com" target="_blank">
            ITLOGIKO
          </a>
          .
        </strong>{' '}
        All rights reserved.
      </footer>
    );
  }
}
